import type { NavigationConfig, FooterConfig } from "@site-factory/config";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { cn } from "../utils";
import { ScrollToHash } from "../components/ScrollToHash";

export interface PageShellProps {
  siteName: string;
  navigation: NavigationConfig;
  footer?: FooterConfig;
  logoUrl?: string;
  currentPath?: string;
  currentHash?: string;
  linkComponent?: (props: { href: string; className?: string; children: React.ReactNode }) => JSX.Element;
  stickyHeader?: boolean;
  footerText?: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * Simple page shell that wires the shared header/footer around routed content.
 */
export function PageShell({
  siteName,
  navigation,
  footer,
  logoUrl,
  currentPath,
  currentHash,
  linkComponent,
  stickyHeader = true,
  footerText,
  className,
  children,
}: PageShellProps) {
  return (
    <div className={cn("min-h-screen flex flex-col bg-background text-foreground", className)}>
      <SiteHeader
        siteName={siteName}
        navigation={navigation}
        logoUrl={logoUrl}
        currentPath={currentPath}
        linkComponent={linkComponent}
        sticky={stickyHeader}
      />

      <main className="flex-1">
        {children}
        <ScrollToHash hash={currentHash} offset={80} />
      </main>

      <SiteFooter
        siteName={footerText ?? siteName}
        linkComponent={linkComponent}
        {...footer}
      />
    </div>
  );
}
